import { api } from './api';

/** Creates the EducAitor profile and the school; the caller becomes its leader and owner. */
export async function registerSchool(email: string, name: string, schoolName: string) {
  await api('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email: email.trim().toLowerCase(), name: name.trim(), schoolName: schoolName.trim(), role: 'school_leader' }),
  });
}

/** Sign-up details kept for this tab only, so a reload during the code step can finish. */
const KEY = 'educaitor.pendingSignUp';
export type PendingSignUp = { email: string; name: string; schoolName: string; inviteToken?: string };
export function savePending(p: PendingSignUp) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // Storage refused: the form still works without surviving a reload.
  }
}
export function readPending(): PendingSignUp | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as PendingSignUp) : null;
  } catch {
    return null;
  }
}
export function clearPending() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
